<template>
    <div class="c-select c-multi-select" @click="toggle" v-click-outside="close">
        <div class="multi-select__placeholder">{{ placeholder }}</div>
        <ul class="multi-select-list" :class="{'multi-select-list--open' : visible}">
            <li class="multi-select-list__item"
                v-for="(item, index) in filteredItems"
                :value="item.name"
                :key="index"
                @click="select(item.name)">
                {{ item.name }}
            </li>
        </ul>
    </div>
</template>

<script>
    import clickOutside from "../directives/click-outside.js";

    export default {
        props: {
            items: { type: Array },
            value: { type: Array },
            placeholder: { type: String }
        },
        data: function () {
            return {
                visible: false
            };
        },
        computed: {
            filteredItems: function () {
                return this.items.filter((item) => {
                    return this.value.includes(item.name) === false;
                });
            }
        },
        methods: {
            toggle: function () {
                this.visible = !this.visible;
            },
            close: function () {
                this.visible = false;
            },
            select: function (item) {
                if (!this.value.includes(item)) {
                    this.value.push(item);
                    this.$emit("select", item);
                    this.close();
                }
            }
        },
        directives: {
            clickOutside
        }
    };
</script>